<template>
	<div class="cards-container-layout" :class="{ 'is-selected': isSelected, 'has-selection': !isTemplateMode && isSelectionOn }">
		<div class="card-layout">
			<SIcon v-if="!isTemplateMode" name="field-checkbox" class="checkbox-icon" />
			<CardRow
				v-if="rowTemplate"
				class="card-header"
				:class="{ 'has-body': hasBody }"
				:cardData="cardData"
				:isTemplateMode="isTemplateMode"
				:rowTemplate="rowTemplate"
				:highlightFieldIndex="highlightFieldIndex"
			/>
			<template v-if="hasBody">
				<div class="card-body" v-for="(boxRow, i) in cardTemplateBody" :key="i">
					<CardRow
						:cardData="cardData"
						:rowTemplate="boxRow"
						v-if="boxRow?.length > 0"
						:isTemplateMode="isTemplateMode"
						:highlightFieldIndex="highlightFieldIndex"
					/>
				</div>
			</template>
		</div>
	</div>
</template>

<script>
import CardRow from './CardRow';

export default {
	name: 'CardDisplay',
	components: {
		CardRow,
	},
	props: {
		cardData: { type: Object },
		cardTemplate: { type: Object },
		highlightFieldIndex: { type: Number, default: null },
		isSelectionOn: { type: Boolean },
		isSelected: { type: Boolean, default: false },
		isTemplateMode: { type: Boolean },
	},
	computed: {
		rowTemplate() {
			return this.cardTemplate?.header;
		},
		cardTemplateBody() {
			return this.cardTemplate?.body;
		},
		hasBody() {
			return this.cardTemplateBody?.[0].length > 0;
		},
	},
};
</script>

<style scoped lang="scss">
.cards-container-layout {
	$border: 1px solid var(--button-border);
	$header-bg: #dfe7f7;
	$bg: var(--bg-color);

	position: relative;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: flex-start;
	transition: 0.3s;

	&.has-selection:hover .card-layout {
		cursor: pointer;
		box-shadow: 0px 1px 1px rgb(66 66 66 / 30%);
		transition: 0.1s;
	}
	&.is-selected .card-layout {
		border: var(--bold-border);
		transition: 0.3s;
	}

	.card-layout {
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
		width: 100%;
		background-color: $bg;
		color: #303133;
		border: $border;
		border-radius: 7px;

		.card-header {
			background-color: #fcfbfb;
			font-weight: 400;
			border-bottom: $border;
			border-top-right-radius: 6px;
			border-top-left-radius: 6px;

			&:not(.has-body) {
				border-radius: 6px !important;
			}
		}
		.card-body {
			width: 100%;
			max-width: 100%;
			flex-direction: column;
			display: flex;
		}
	}
	.checkbox-icon {
		position: absolute !important;
		top: 0;
		left: 0;
		transform: translate(-30%, -25%);
		z-index: $z-index-2;

		::v-deep(svg) {
			opacity: 0;
			background-color: $bg;

			path {
				stroke: transparent;
			}
		}
	}

	&.has-selection {
		&.is-selected .checkbox-icon {
			::v-deep(svg) {
				background-color: $bg;
				opacity: 1;

				path,
				rect {
					stroke: var(--primary-color);
				}
			}
		}
		&:hover:not(.is-selected) {
			::v-deep(svg) {
				background-color: #fcfbfb;
				opacity: 1;

				rect {
					stroke: var(--button-border);
				}
			}
		}
	}

	.dummy-filler {
		width: 100%;
		padding: 5px;

		> div {
			height: 10px;
			border-radius: 20px;
			background-color: #e6e7ec;
		}
		&.is-highlight > div {
			border: 1px solid var(--primary-color);
			background-color: #afd9f8;
		}
	}
	@media (max-width: $device-sm) {
		&.has-selection {
			.checkbox-icon {
				::v-deep(svg) {
					opacity: 1 !important;

					rect {
						stroke: var(--button-border) !important;
					}
				}
			}
		}
		.card-layout {
			box-shadow: none !important;
		}
	}
}
</style>
